/*! PET-25 affiliate click tracker — producer.
 * Publishes an `affiliate_click` custom event on every affiliate CTA click.
 * Transport/sink live in a Shopify Custom Pixel (see custom-pixel.js), so the
 * destination can change without a theme publish.
 *
 * Selector is rel~="sponsored" — the FTC-required attribute every affiliate CTA
 * already carries — so PET-10 slots, PET-13 blog blocks and PET-15's swapped
 * links are all covered with no per-placement wiring.
 */
(function () {
  if (window.__petstoreAffClick) return;
  window.__petstoreAffClick = true;

  function partnerFromHref(href) {
    try {
      var host = new URL(href, location.href).hostname.replace(/^www\./, '');
      return host === location.hostname.replace(/^www\./, '') ? '' : host;
    } catch (e) {
      return '';
    }
  }

  function build(a) {
    var slot = a.closest('[data-aff-placement], .aff-slot');
    var href = a.getAttribute('href') || '';
    // Placeholder CTAs (#partner-pending-*) are staged but not yet affiliated.
    // They still signal demand, so we record them as status:"pending" and keep
    // the guardrail metric to status:"outbound".
    var outbound = /^https?:/i.test(href);

    function attr(name) {
      return a.dataset[name] || (slot && slot.dataset[name]) || '';
    }

    return {
      page: location.pathname,
      placement: attr('affPlacement') || (slot && slot.dataset.affContext) || 'unattributed',
      vertical: attr('affVertical'),
      partner: attr('affPartner') || partnerFromHref(href),
      status: outbound ? 'outbound' : 'pending',
      url: outbound ? href : ''
    };
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[rel~="sponsored"]');
      if (!a) return;
      var payload = build(a);
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('affiliate_click', payload);
        }
      } catch (err) {
        /* never block the outbound navigation */
      }
    },
    // capture: fires before the placeholder CTAs' own `onclick="return false"`
    true
  );
})();
